/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */


if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form-main');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();
      this.variant = this.getSelectedVariant();   
      this.selectedOptions = this.getSelectedOptions();  
      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;

      this.addEventListener('change', this.handleVariantChange.bind(this));

      // Defer these to allow for quick-add modal to full initialize
      setTimeout(() => {
        this.updateAvailability();
        this.updateAddToCartButton();
        this.updateSaleIndicator(); // Added to update sale indicator on load.
      });
    }


    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();
      
      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;

      if (this.variant) {
        this.updateMedia();
        this.updateUrl(evt);
        this.updateVariantInput();
      }

      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateMessage();      
      this.updateWeight();
      this.updateBarcode();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      this.updateSeason();
      this.updateMetafieldVisibility();
      this.updateSaleIndicator();
      VariantPicker.updateLabelText(evt);

      //custom by Mr Shoe
      // Trigger product-handling updates
      const productHandling = this.section.querySelector('product-handling');
      if (productHandling) {
        // Update product-handling attributes
        productHandling.setAttribute('data-id', this.variant.id);
        productHandling.setAttribute('data-product-price', this.variant.price);
        // Dispatch a custom event to notify the product-handling component
        productHandling.dispatchEvent(
          new CustomEvent('variantChange', {
            bubbles: true,
            detail: { variant: this.variant },
          })
        );
      } else {
        console.warn('No product-handling element found');
      }

      const productDelivery = this.section.querySelector('product-delivery');
      if (productDelivery) {
          productDelivery.setAttribute('data-id', this.variant.id);
        // Dispatch a custom event to notify the product-handling component
        productDelivery.dispatchEvent(
          new CustomEvent('variantChange', {
            bubbles: true,
            detail: { variant: this.variant },
          })
        );
      } else {
        console.warn('No product-delivery element found');
      }

      
      
      //custom by Mr Shoe 

      if (!this.preSelection) {
        this.dispatchEvent(new CustomEvent('on:variant:change', {
          bubbles: true,
          detail: {
            form: this.productForm,
            variant: this.variant,
            product: this.data.product
          }
        }));
      }
    }

    /**
     * Shows/hides variant metafield elements on the page as necessary
     */
    updateMetafieldVisibility() {
      document.querySelectorAll('[data-variant-metafield]').forEach((elem) => {
        elem.classList.toggle('hidden', elem.dataset.variantMetafield !== this.variant?.id.toString());
      });
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector('.js-product-form-main');
      if (!this.productForm) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;

      this.addBtn.disabled = !variantAvailable || this.preSelection;

      if (this.preSelection) {
        this.addBtn.textContent = theme.strings.noSelectedVariant;
      } else {

        const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;
        this.addBtn.textContent = variantAvailable
          ? this.addBtn.dataset.addToCartText
          : unavailableStr;
      }
    }


/**
 * Updates an option element to indicate if it leads to a sale.
 * Hides options that are not on sale if the URL contains "sale".
 * @param {Element} optionEl - The option element (the radio input).
 * @param {boolean} isSale - Whether this option should be marked as on sale.
 * @param {string} saleText - The text to display (e.g. as a title) when on sale.
 * @param {boolean} modal - Whether this function is running inside a modal.
 */
static updateOptionSale(optionEl, isSale, saleText, modal) {
let isSalePage = false;
if (modal) {
  // If in modal mode, only check the current URL for the sale parameter.
  isSalePage = window.location.href.includes("filter.v.m.variant.compare_at_price=1");
} else {
  // If not in modal mode, check that the previous URL includes the sale parameter
  // and ensure the current URL does not include "&_ss=e".
  isSalePage = document.referrer.includes("filter.v.m.variant.compare_at_price=1") &&
               window.location.href.includes("&_ss=c");
}


    // Always ensure sale options are visible
    if (isSale) {
        optionEl.style.display = ""; // Make sure the option is shown
        const label = document.querySelector(`label[for="${optionEl.id}"]`);
        if (label) label.style.display = ""; // Ensure label is visible
    } else if (isSalePage) {
        optionEl.style.display = "none"; // Hide non-sale options on sale page
        const label = document.querySelector(`label[for="${optionEl.id}"]`);
        if (label) label.style.display = "none"; // Hide corresponding label
        return;
    } else {
        optionEl.style.display = ""; // Restore display for all other cases
        const label = document.querySelector(`label[for="${optionEl.id}"]`);
        if (label) label.style.display = "";
    }

    // Update sale styling
    optionEl.classList.toggle('is-sale', isSale);
    const label = document.querySelector(`label[for="${optionEl.id}"]`);
    if (!label) return;

    if (isSale) {
        label.setAttribute('title', saleText);
        label.classList.add('is-sale');

        // Ensure a sale dot exists
        if (!label.querySelector(".sale-dot")) {
            const saleDot = document.createElement("span");
            saleDot.classList.add("sale-dot");
            label.appendChild(saleDot);
        }
    } else {
        label.removeAttribute('title');
        label.classList.remove('is-sale');

        // Remove sale dot if it exists
        const existingSaleDot = label.querySelector(".sale-dot");
        if (existingSaleDot) {
            existingSaleDot.remove();
        }
    }
}


    

    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    static updateOptionAvailability(optionEl, exists, available, id, data) {
      const el = optionEl;
      const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
      el.classList.toggle('is-unavailable', !available);
      el.classList.toggle('is-nonexistent', !exists);

      if (optionEl.classList.contains('custom-select__option')) {
        const em = el.querySelector('em');

        if (em) {
          em.hidden = available;
        }

        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
          }
        }
      } else if (!available) {
        el.nextElementSibling.title = unavailableText;
      } else {
        el.nextElementSibling.removeAttribute('title');
      }


        const text = exists ? theme.strings.noStock : theme.strings.noVariant;

        if (optionEl.classList.contains('custom-select__option')) {
          //Custom placement by Mr Shoe
           el.classList.toggle('is-unavailable', !available);
          const em = el.querySelector('em');
          
          if (em) {
            em.hidden = available;
          }
    
          if (!available) {
            if (em) {
             em.textContent = text;
            } else {
              el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${text}</em>`;
            }
          }
        } else if (!available) {
          el.nextElementSibling.title = text;
        } else {
          el.nextElementSibling.removeAttribute('title');
        }
      
    }

    
updateSaleIndicator() {
  // Ensure that product data and variants exist.
  if (!this.data.product || !this.data.product.variants) {
    console.warn("No product data or variants available.");
    return;
  }

  // Loop through each option selector (like in updateAvailability)
  this.optionSelectors.forEach((selector, selectorIndex) => {
    // Select all option elements inside this selector that are not placeholders.
    const options = selector.querySelectorAll('.js-option:not([data-value=""])');
    
    options.forEach((option) => {
      // Get the option value (for dropdowns or normal radio/checkbox inputs)
      const optionValue = selector.dataset.selectorType === 'dropdown'
        ? option.dataset.value
        : option.value;
      
      let isSale = false;
      
      // Check each variant to see if it matches previous selections and this option
      this.data.product.variants.forEach((variant) => {
        let matches = 0;
        // For all selectors before the current one, ensure the variant's option matches the selected option (if any).
        for (let i = 0; i < selectorIndex; i += 1) {
          if (this.selectedOptions[i] === null || variant.options[i] === this.selectedOptions[i]) {
            matches++;
          }
        }
        
        // Only consider variants that match all previous selections
        if (matches === selectorIndex && variant.options[selectorIndex] === optionValue) {
          // Check if this variant is on sale:
          // (i.e. compare_at_price exists and is greater than the variant price)
          if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price) && variant.available) {
            isSale = true;
          }
        }
      });
      
      // Update the option element (and its associated label) using the static method.
      // Here, "Sale" is the text used as a title; adjust as needed.
      VariantPicker.updateOptionSale(option, isSale, "Sale", this.section.matches('quick-add-drawer'));
    });
  });
}



    
    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;
      const { availabilityMethod } = this.dataset; // 'downward' or 'selection'
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.selectedOptions };
      }

      if (availabilityMethod === 'selection') {
        // Flag all options as unavailable
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          VariantPicker.updateOptionAvailability(optionEl, false, false);
        });

        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.product.variants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === 'dropdown') {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                VariantPicker.updateOptionAvailability(optionEl, true, variant.available, variant.id, this.data);
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll('.js-option:not([data-value=""])');
          options.forEach((option) => {

            const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
            // any available variants with previous options and this one locked in?
            let vid;
            let variantsExist = false;
            let variantsAvailable = false;
            this.data.product.variants.forEach((v) => {
              let matches = 0;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (v.options[i] === this.selectedOptions[i] || this.selectedOptions[i] === null) {
                  matches += 1;
                }
              }
              if (v.options[selectorIndex] === optionValue && matches === selectorIndex) {
                variantsExist = true;
                vid = v.id;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            VariantPicker.updateOptionAvailability(option, variantsExist, variantsAvailable, vid, this.data);
          });
        });
      }
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default')
            ? ''
            : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;

      if (this.section.matches('quick-add-drawer')) {
        this.section.updateMedia(this.variant.featured_media.id);
      } else {
        this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-info__price > .price');
      if (!this.price) return;

      let { variant } = this;
      if (this.preSelection) {
        variant = this.data.product.variants[0];
        for (let i = 1; i < this.data.product.variants.length; i += 1) {
          if (this.data.product.variants[i].price < variant.price) variant = this.data.product.variants[i];
        }
      }

      if (this.variant) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');

        // Update current price and original price if on sale.
        priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price;
        if (priceWasEl)
          priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || '';

        // Update unit price, if specified.
        if (this.variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = this.variant.unit_price_measurement.reference_value;
          const unit = this.variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }

        unitPriceEl.hidden = !this.variant.unit_price_measurement;
        this.price.classList.toggle(
          'price--on-sale',
          this.variant.compare_at_price > this.variant.price
        );
        this.price.classList.toggle('price--sold-out', !this.variant.available && !this.preSelection);
      }

      this.price.querySelector('.price__default').hidden = !this.variant && !this.preSelection;
      this.price.querySelector('.price__no-variant').hidden = this.variant || this.preSelection;
      const from = this.price.querySelector('.price__from');
      if (from) {
        from.hidden = !this.preSelection;
      }
    }


    updateMessage() {
      this.saleMessage = this.saleMessage || this.section.querySelector('product-message.text-sale-return-policy');
      if (!this.saleMessage) return;  
      this.saleMessage.style.display = "none";
        if (this.data.formatted[this.variant.id].compareAtPrice != null)
        this.saleMessage.style.display = "block";  
    }

    
    /**
     * Updates the weight.
     */
    updateWeight() {
      this.weights = this.weights || this.section.querySelectorAll('.product-info__weight');
      if (this.weights.length === 0) return;

      const weightAvailable = this.variant && this.variant.weight > 0;
      this.weights.forEach((weight) => {
        weight.textContent = weightAvailable ? this.data.formatted[this.variant.id].weight : '';
        weight.hidden = !weightAvailable;
      });
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcodes = this.barcodes || this.section.querySelectorAll('.product-info__barcode-value');
      if (this.barcodes.length === 0) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcodes.forEach((barcode) => {
        barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
        barcode.parentNode.hidden = !barcodeAvailable;
      });
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */

    //custom by Mr Shoe
updateUrl(evt) {
  if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;

  // Get the current URL
  const url = new URL(window.location.href);

  // Update only the 'variant' query parameter
  url.searchParams.set('variant', this.variant.id);

  // Push the updated URL to the browser history
  window.history.replaceState({}, '', url.toString());
}


    /**
     * Updates the season.
     */
    updateSeason() {
      this.season = this.season || this.section.querySelector('.product-season__value');
      if (!this.season) return;
      const seasonAvailable = this.variant && this.data.formatted[this.variant.id].season;
      this.season.textContent = seasonAvailable ? this.data.formatted[this.variant.id].season : '';
      this.season.parentNode.hidden = !seasonAvailable;
    }    

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms || this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          const selectedText = selector.querySelector('.custom-select__btn').textContent.trim();
          selectedOptions.push(selectedText === this.dataset.placeholderText ? null : selectedText);
        } else {
          const selected = selector.querySelector('input:checked');
          selectedOptions.push(selected ? selected.value : null);
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
getSelectedVariant() {
  const selectedOptions = this.getSelectedOptions();
  let isSalePage = false;


if (this.section.matches('quick-add-drawer')) {
  // If in modal mode, only check the current URL for the sale parameter.
  isSalePage = window.location.href.includes("filter.v.m.variant.compare_at_price=1");
} else {
  // If not in modal mode, check that the previous URL includes the sale parameter
  // and ensure the current URL does not include "&_ss=e".
  isSalePage = document.referrer.includes("filter.v.m.variant.compare_at_price=1") &&
               window.location.href.includes("&_ss=c");
}

  if (!isSalePage) {
    // Default behavior: Find an exact match if not on sale page
    return this.data.product.variants.find(
      (v) => v.options.every((val, index) => val === selectedOptions[index])
    );
  }

  // Get only sale variants (compare_at_price > price)
  const saleVariants = this.data.product.variants.filter(
    (v) => v.compare_at_price && Number(v.compare_at_price) > Number(v.price)
  );

  // 1. Try to find an exact match first
  let exactMatch = saleVariants.find(
    (v) => v.options.every((val, index) => val === selectedOptions[index])
  );

  if (exactMatch && exactMatch.available) {
    this.markOptionSelected(exactMatch);
    return exactMatch;
  }

  // 2. If no exact match, match first option and find the best second and third options
  const [selectedFirst, selectedSecond, selectedThird] = selectedOptions;

  // Filter sale variants by first option (e.g., Brown)
  const filteredByFirst = saleVariants.filter((v) => v.options[0] === selectedFirst);

  if (filteredByFirst.length > 0) {
    // Find the closest valid second option (e.g., nearest UK size that is on sale)
    let bestSecondOptionVariant = filteredByFirst.find((v) => v.options[1] === selectedSecond && v.available);

    if (!bestSecondOptionVariant) {
      // If the selected second option is not available, pick the closest one
      const sortedBySize = filteredByFirst
        .filter((v) => v.available)
        .sort((a, b) => parseFloat(a.options[1].replace(/[^\d.]/g, '')) - parseFloat(b.options[1].replace(/[^\d.]/g, '')));

      bestSecondOptionVariant = sortedBySize.length > 0 ? sortedBySize[0] : null;
    }

    if (bestSecondOptionVariant) {
      // Now, validate the third option based on the newly selected size
      const filteredByFirstAndSecond = saleVariants.filter(
        (v) => v.options[0] === selectedFirst && v.options[1] === bestSecondOptionVariant.options[1]
      );

      let bestThirdOptionVariant = filteredByFirstAndSecond.find(
        (v) => v.options[2] === selectedThird && v.available
      );

      if (!bestThirdOptionVariant) {
        // If the originally selected third option is not available, find the closest sale variant
        bestThirdOptionVariant = filteredByFirstAndSecond.find((v) => v.available);
      }

      if (bestThirdOptionVariant) {
        this.markOptionSelected(bestThirdOptionVariant);
        return bestThirdOptionVariant;
      }
    }
  }

  // 3. If no valid second/third option, fall back to the first available sale variant
  const fallbackVariant = saleVariants.find((v) => v.available) || null;

  if (fallbackVariant) {
    this.markOptionSelected(fallbackVariant);
    return fallbackVariant;
  }

  // 4. No valid sale variants found, return null
  return null;
}


     // custom by mr shoe

//custom by Mr Shoe
/**
 * Marks the correct radio button as selected for the closest variant.
 * @param {Object} variant - The variant object to select.
 */
markOptionSelected(variant) {
  this.optionSelectors.forEach((selector, selectorIndex) => {
    const options = selector.querySelectorAll('input[type="radio"]');
    
    options.forEach((option) => {
      const optionValue = option.value;
      if (variant.options[selectorIndex] === optionValue) {
        option.checked = true; // Select the closest available option
      }
    });
  });
  // Update the internal selectedOptions to reflect the new state.
  this.selectedOptions = this.getSelectedOptions();
}


//custom by Mr Shoe    
    
    
  }

  customElements.define('variant-picker', VariantPicker);
}
